var map = {
  "./cs.json": [
    "XT6",
    [
      "hp8"
    ]
  ],
  "./en.json": [
    "KUC",
    [
      "4q"
    ]
  ],
  "./pl.json": [
    "w1",
    [
      "mz"
    ]
  ],
  "./ru.json": [
    "xO1",
    [
      "fo4"
    ]
  ],
  "./tr.json": [
    "SM",
    [
      "se"
    ]
  ],
  "./ja.json": [
    "sP",
    [
      "e6"
    ]
  ],
  "./zh.json": [
    "o6J",
    [
      "u4m"
    ]
  ],
  "./pt-br.json": [
    "Jb",
    [
      "f2"
    ]
  ],
  "./de.json": [
    "yPS",
    [
      "kej"
    ]
  ],
  "./es.json": [
    "XJ",
    [
      "toi"
    ]
  ],
  "./fr.json": [
    "Vm",
    [
      "bz"
    ]
  ],
  "./it.json": [
    "qg",
    [
      "0i"
    ]
  ],
  "./ko.json": [
    "Ml",
    [
      "y0"
    ]
  ],
  "./pt.json": [
    "HG",
    [
      "p0"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "rz";
module.exports = __rspack_async_context;
